<template>
  <v-app>
    <GlobalEvents @mousemove="refresh" />
    <!--------------------------------------NAVIGATION DRAWER-------------------------------------->
    <v-navigation-drawer
      v-if="logged == true"
      ref="navDrawer"
      v-model="drawer"
      :rail="mini"
      theme="dark"
      fixed
      clipped
      app
      width="320"
      rail-width="112"
    >
      <!-- USER DETAILS (SM AND DOWN) -->
      <v-row
        v-if="$vuetify.display.smAndDown"
        column
        class="grey-darken-4 pa-1"
      >
        <v-col>
          <span class="white--text font-weight-bold">{{
            $store.getters.userName
          }}</span>
        </v-col>
        <v-col>
          <span class="white--text font-weight-bold">{{
            getRole($store.getters.role)
          }}</span>
        </v-col>
        <v-col>
          <span class="white--text font-weight-bold">
            {{ $t("approved_parts") }}: {{ $store.getters.approvedPartsNumber }}
          </span>
        </v-col>
      </v-row>

      <!-- NAVIGATION LIST -->
      <v-list density="compact" nav>
        <div class="d-flex">
          <router-link to="/inventory">
            <img v-if="mini" height="50" src="@/assets/logo_small_w.png" />
            <img v-else height="50" src="@/assets/logo.png" class="mt-2" />
          </router-link>
          <v-spacer></v-spacer>
          <!-- NAVIGATION BUTTON -->
          <v-btn
            v-if="logged == true && $vuetify.display.lgAndUp"
            size="small"
            color="red"
            icon
            class="nav-btn mt-2"
            @click.stop="mini = !mini"
          >
            <v-icon>
              {{ mini ? "mdi-arrow-right" : "mdi-arrow-left" }}
            </v-icon>
          </v-btn>
        </div>

        <!------------------------------------------HOME------------------------------------------->
        <v-list-item
          :to="{ name: items.home.href }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>mdi-home</v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            items.home.title
          }}</v-list-item-title>
        </v-list-item>
        <!------------------------------------WHATSAPP INBOX (SSO)----------------------------------->
      <!--   <v-list-item
          v-if="canWhatsAppInbox"
          class="menuList listHover"
          @click="openWhatsappInboxFromMenu"
        >
          <template #prepend>
            <v-icon>mdi-message-text-outline</v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            items.whatsappInbox.title
          }}</v-list-item-title>
        </v-list-item>
        <whatsapp-inbox-button
          ref="whatsappInboxLauncher"
          class="d-none"
          @error="onWhatsappInboxError"
        />
        ---->
        <!------------------------------------------PARTS------------------------------------------>
        <!-- <v-list-item
      v-if="$store.getters.role == 'User' || $store.getters.role == 'EbayOperator'
        || $store.getters.role == 'InstitutionManager'
        || $store.getters.role == 'InstitutionAdmin'
        || $store.getters.role == 'LekoAdmin'
        || $store.getters.role == 'LekoEmployee'
        || $store.getters.role == 'SuperAdmin'
      "
      active-class="title black--text redColor"
      class="menuList listHover shrink"
    >
      <template v-slot:prepend>
        <v-icon>
          <img
          height="24"
          width="24"
          src="@/assets/icons/parts.svg"
        >
        </v-icon>
      </template>
      <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{ items.parts.title }}</v-list-item-title>
      <template v-slot:append v-if="!mini">
        <v-chip
          label
          size="small"
          color="primary"
          text-color="white"
        >
          {{ $store.getters.totalParts }}
        </v-chip>
      </template>
    </v-list-item> -->
        <!--INSERT PARTS-->
        <v-list-item
          v-if="
            $store.getters.role == 'User' ||
            $store.getters.role == 'EbayOperator' ||
            $store.getters.role == 'InstitutionManager' ||
            $store.getters.role == 'InstitutionAdmin' ||
            $store.getters.role == 'LekoAdmin' ||
            $store.getters.role == 'LekoEmployee' ||
            $store.getters.role == 'SuperAdmin'
          "
          :to="{ name: items.parts.href }"
          active-class="title black--text redColor"
          class="menuList listHover blueText"
        >
          <template #prepend>
            <v-icon>
              <img
                height="24"
                width="24"
                src="@/assets/icons/insert_parts.svg"
              />
            </v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            items.parts.subtitle
          }}</v-list-item-title>
          <template v-if="!mini" #append>
            <v-chip
              label
              size="small"
              color="primary"
              variant="elevated"
              text-color="white"
            >
              {{ $store.getters.temporaryParts }}
            </v-chip>
          </template>
        </v-list-item>
        <!--INVENTORY-->
        <v-list-item
          v-if="
            $store.getters.role == 'User' ||
            $store.getters.role == 'EbayOperator' ||
            $store.getters.role == 'InstitutionManager' ||
            $store.getters.role == 'InstitutionAdmin' ||
            $store.getters.role == 'LekoAdmin' ||
            $store.getters.role == 'LekoEmployee' ||
            $store.getters.role == 'SuperAdmin'
          "
          :to="{ name: items.parts.href1 }"
          active-class="title black--text redColor"
          class="menuList listHover blueText"
        >
          <template #prepend>
            <v-icon>
              <img height="24" width="24" src="@/assets/icons/inventory.svg" />
            </v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            items.parts.subtitle1
          }}</v-list-item-title>
          <template v-if="!mini" #append>
            <v-chip
              label
              size="small"
              color="primary"
              variant="elevated"
              text-color="white"
            >
              {{ $store.getters.inventory }}
            </v-chip>
          </template>
        </v-list-item>
        <!--PRICE 1 AVERAGES-->
        <v-list-item
          v-if="
            $store.getters.role == 'EbayOperator' ||
            $store.getters.role == 'InstitutionManager' ||
            $store.getters.role == 'InstitutionAdmin' ||
            $store.getters.role == 'LekoAdmin' ||
            $store.getters.role == 'LekoEmployee' ||
            $store.getters.role == 'SuperAdmin'
          "
          :to="{ name: items.priceOneAverages.href }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>mdi-cash-multiple</v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            items.priceOneAverages.title
          }}</v-list-item-title>
        </v-list-item>
        <!--DAMAGED PARTS-->
        <v-list-item
          v-if="
            $store.getters.role == 'User' ||
            $store.getters.role == 'EbayOperator' ||
            $store.getters.role == 'InstitutionManager' ||
            $store.getters.role == 'InstitutionAdmin' ||
            $store.getters.role == 'LekoAdmin' ||
            $store.getters.role == 'LekoEmployee' ||
            $store.getters.role == 'SuperAdmin'
          "
          :to="{ name: items.parts.href3 }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>
              <img
                height="24"
                width="24"
                src="@/assets/icons/damaged_parts.svg"
              />
            </v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            items.parts.subtitle3
          }}</v-list-item-title>
        </v-list-item>
        <!--LOST PARTS-->
        <v-list-item
          v-if="
            $store.getters.role == 'User' ||
            $store.getters.role == 'EbayOperator' ||
            $store.getters.role == 'InstitutionManager' ||
            $store.getters.role == 'InstitutionAdmin' ||
            $store.getters.role == 'LekoAdmin' ||
            $store.getters.role == 'LekoEmployee' ||
            $store.getters.role == 'SuperAdmin'
          "
          :to="{ name: items.parts.href4 }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>
              <img height="24" width="24" src="@/assets/icons/lost_parts.svg" />
            </v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            items.parts.subtitle4
          }}</v-list-item-title>
        </v-list-item>
        <!--RECYCLED PARTS-->
        <v-list-item
          v-if="
            $store.getters.role == 'User' ||
            $store.getters.role == 'EbayOperator' ||
            $store.getters.role == 'InstitutionManager' ||
            $store.getters.role == 'InstitutionAdmin' ||
            $store.getters.role == 'LekoAdmin' ||
            $store.getters.role == 'LekoEmployee' ||
            $store.getters.role == 'SuperAdmin'
          "
          :to="{ name: items.parts.href5 }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>
              <img
                height="24"
                width="24"
                src="@/assets/icons/recycled_parts.svg"
              />
            </v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            items.parts.subtitle5
          }}</v-list-item-title>
        </v-list-item>
        <!--MOVEMENTS-->
        <v-list-item
          v-if="
            $store.getters.role == 'User' ||
            $store.getters.role == 'EbayOperator' ||
            $store.getters.role == 'InstitutionManager' ||
            $store.getters.role == 'InstitutionAdmin' ||
            $store.getters.role == 'LekoAdmin' ||
            $store.getters.role == 'LekoEmployee' ||
            $store.getters.role == 'SuperAdmin'
          "
          :to="{ name: items.parts.href6 }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>
              <img height="24" width="24" src="@/assets/icons/movements.svg" />
            </v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            items.parts.subtitle6
          }}</v-list-item-title>
        </v-list-item>
        <!------------------------------------------SALES------------------------------------------>
        <v-list-item
          v-if="
            $store.getters.role == 'User' ||
            $store.getters.role == 'EbayOperator' ||
            $store.getters.role == 'InstitutionManager' ||
            $store.getters.role == 'InstitutionAdmin' ||
            $store.getters.role == 'LekoAdmin' ||
            $store.getters.role == 'LekoEmployee' ||
            $store.getters.role == 'SuperAdmin'
          "
          :to="{ name: items.sales.href }"
          active-class="title black--text redColor"
          class="menuList listHover blueText"
        >
          <template #prepend>
            <v-icon>mdi-sale</v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            items.sales.title
          }}</v-list-item-title>
        </v-list-item>
        <!--------------------------------------ORDERED PARTS-------------------------------------->
        <v-list-item
          v-if="
            $store.getters.role == 'User' ||
            $store.getters.role == 'EbayOperator' ||
            $store.getters.role == 'InstitutionManager' ||
            $store.getters.role == 'InstitutionAdmin' ||
            $store.getters.role == 'LekoAdmin' ||
            $store.getters.role == 'LekoEmployee' ||
            $store.getters.role == 'SuperAdmin'
          "
          :to="{ name: items.parts.href2 }"
          active-class="title black--text redColor"
          class="menuList listHover blueText"
        >
          <template #prepend>
            <v-icon>
              <img
                height="24"
                width="24"
                src="@/assets/icons/ordered_parts.svg"
              />
            </v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            items.parts.subtitle2
          }}</v-list-item-title>
          <template v-if="!mini" #append>
            <v-chip
              label
              size="small"
              color="primary"
              variant="elevated"
              text-color="white"
            >
              {{ $store.getters.orderedParts }}
            </v-chip>
          </template>
        </v-list-item>
        <!--------------------------------------PART REQUESTS-------------------------------------->
        <v-list-item
          v-if="$store.getters.role == 'SuperAdmin'"
          :to="{ name: items.partRequests.href }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>mdi-shopping</v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            items.partRequests.title
          }}</v-list-item-title>
          <v-list-item-subtitle
            v-if="!mini"
            class="text-grey text-caption"
          >
            {{ items.partRequests.subtitle }}
          </v-list-item-subtitle>
        </v-list-item>
        <!--------------------------------------RESERVATIONS--------------------------------------->
        <v-list-item
          v-if="$store.getters.role == 'SuperAdmin'"
          :to="{ name: items.reservations.href }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>mdi-calendar-month</v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            items.reservations.title
          }}</v-list-item-title>
          <v-list-item-subtitle
            v-if="!mini"
            class="text-grey text-caption"
          >
            {{ items.reservations.subtitle }}
          </v-list-item-subtitle>
        </v-list-item>
        <!----------------------------------------VEHICLES----------------------------------------->
        <!-- <v-list-item
          v-if="
            $store.getters.role == 'User' || $store.getters.role == 'EbayOperator' ||
            $store.getters.role == 'InstitutionManager' ||
            $store.getters.role == 'InstitutionAdmin' ||
            $store.getters.role == 'LekoAdmin' ||
            $store.getters.role == 'LekoEmployee' ||
            $store.getters.role == 'SuperAdmin'
          "
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>
              <img height="24" width="24" src="@/assets/icons/vehicles.svg" />
            </v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            items.vehicles.title
          }}</v-list-item-title>
          <template v-if="!mini" #append>
            <v-chip label size="small" color="primary" text-color="white">
              {{ $store.getters.vehicles }}
            </v-chip>
          </template>
        </v-list-item> -->
        <!--VEHICLE ENTRY-->
        <v-list-item
          v-if="
            $store.getters.role == 'User' ||
            $store.getters.role == 'EbayOperator' ||
            $store.getters.role == 'InstitutionManager' ||
            $store.getters.role == 'InstitutionAdmin' ||
            $store.getters.role == 'LekoAdmin' ||
            $store.getters.role == 'LekoEmployee' ||
            $store.getters.role == 'SuperAdmin'
          "
          :to="{ name: items.vehicles.href2 }"
          active-class="title black--text redColor"
          class="menuList listHover blueText"
        >
          <template #prepend>
            <v-icon>
              <img height="24" width="24" src="@/assets/icons/cars.svg" />
            </v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            items.vehicles.subtitle2
          }}</v-list-item-title>
          <template v-if="!mini" #append>
            <v-chip
              label
              size="small"
              color="primary"
              variant="elevated"
              text-color="white"
            >
              {{ $store.getters.vehicles }}
            </v-chip>
          </template>
        </v-list-item>
        <!--WORKSHOP DEPOLLUTION (Stage 3a): only with the workshop switch on-->
        <v-list-item
          v-if="$store.getters.workshopEnabled"
          :to="{ name: 'workshop' }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>mdi-oil</v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            $t("workshop.nav")
          }}</v-list-item-title>
        </v-list-item>
        <!--WASTE CONTAINERS (Stage 6): only with the waste switch on, no badge-->
        <v-list-item
          v-if="$store.getters.wasteEnabled"
          :to="{ name: 'waste' }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>mdi-barrel</v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            $t("waste.nav")
          }}</v-list-item-title>
        </v-list-item>
        <!-------------------------------------LEKO EMPLOYEES-------------------------------------->
        <v-list-group
          v-if="
            $store.getters.role == 'LekoAdmin' ||
            $store.getters.role == 'LekoEmployee' ||
            $store.getters.role == 'LekoBot' ||
            $store.getters.role == 'SuperAdmin'
          "
          value="lekoEmployees"
        >
          <template #activator="{ props, isOpen }">
            <v-list-item
              v-bind="props"
              active-class="title black--text redColor"
              class="menuList listHover"
            >
              <template #prepend>
                <v-icon>
                  <img
                    height="24"
                    width="24"
                    src="@/assets/icons/leko_employees.svg"
                  />
                </v-icon>
              </template>
              <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
                items.leko.title
              }}</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item
            :to="{ name: items.leko.href }"
            active-class="title black--text redColor"
            class="menuList listHover"
          >
            <template #prepend>
              <v-icon>mdi-cogs</v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.leko.subtitle
            }}</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="$store.getters.role !== 'LekoBot'"
            :to="{ name: items.leko.href2 }"
            active-class="title black--text redColor"
            class="menuList listHover"
          >
            <template #prepend>
              <v-icon>mdi-account-clock</v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.leko.subtitle2
            }}</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="$store.getters.role !== 'LekoBot'"
            :to="{ name: items.leko.href3 }"
            active-class="title black--text redColor"
            class="menuList listHover"
          >
            <template #prepend>
              <v-icon>mdi-cash-register</v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.leko.subtitle3
            }}</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="$store.getters.role !== 'LekoBot'"
            :to="{ name: items.leko.href4 }"
            active-class="title black--text redColor"
            class="menuList listHover"
          >
            <template #prepend>
              <v-icon>mdi-cog</v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.leko.subtitle4
            }}</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="$store.getters.role !== 'LekoBot'"
            :to="{ name: items.leko.href5 }"
            active-class="title black--text redColor"
            class="menuList listHover"
          >
            <template #prepend>
              <v-icon>mdi-account-cog</v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.leko.subtitle5
            }}</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="{ name: items.leko.href1 }"
            active-class="title black--text redColor"
            class="menuList listHover"
          >
            <template #prepend>
              <v-icon>mdi-speedometer</v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.leko.subtitle1
            }}</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="{ name: items.leko.href6 }"
            active-class="title black--text redColor"
            class="menuList listHover"
          >
            <template #prepend>
              <v-icon>mdi-speedometer</v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.leko.subtitle6
            }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-------------------------------------SETTINGS MODULE------------------------------------->
        <v-list-group
          v-if="
            $store.getters.role == 'User' ||
            $store.getters.role == 'EbayOperator' ||
            $store.getters.role == 'InstitutionManager' ||
            $store.getters.role == 'InstitutionAdmin' ||
            $store.getters.role == 'LekoAdmin' ||
            $store.getters.role == 'LekoEmployee' ||
            $store.getters.role == 'SuperAdmin'
          "
          value="setting"
        >
          <template #activator="{ props, isOpen }">
            <v-list-item
              v-bind="props"
              active-class="title black--text redColor"
              class="menuList listHover"
            >
              <template #prepend>
                <v-icon>mdi-cog</v-icon>
              </template>
              <v-list-item-title
                class="listHover blueText"
                :class="mini ? 'd-none' : 'title-font-size'"
              >
                {{ items.settings2.title }}
              </v-list-item-title>
            </v-list-item>
          </template>
          <!---------------------------------------SETTINGS---------------------------------------->
          <v-list-item
            v-if="
              $store.getters.role == 'InstitutionAdmin' ||
              $store.getters.role == 'LekoAdmin' ||
              $store.getters.role == 'LekoEmployee' ||
              $store.getters.role == 'SuperAdmin'
            "
            :to="{ name: items.settings.href }"
            active-class="title black--text redColor"
            class="menuList2 listHover"
          >
            <template #prepend>
              <v-icon class="list-content-2">mdi-account-cog</v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.settings.title
            }}</v-list-item-title>
          </v-list-item>
          <!---------------------------------------SHIPMENTS--------------------------------------->
          <v-list-item
            v-if="
              $store.getters.role == 'User' ||
              $store.getters.role == 'EbayOperator' ||
              $store.getters.role == 'InstitutionManager' ||
              $store.getters.role == 'InstitutionAdmin' ||
              $store.getters.role == 'LekoAdmin' ||
              $store.getters.role == 'LekoEmployee' ||
              $store.getters.role == 'SuperAdmin'
            "
            :to="{ name: items.vehicles.href1 }"
            active-class="title black--text redColor"
            class="menuList2 listHover"
          >
            <template #prepend>
              <v-icon class="list-content-2">mdi-package-variant</v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.vehicles.subtitle1
            }}</v-list-item-title>
          </v-list-item>
          <!-------------------------------------REPOSITORIES-------------------------------------->
          <v-list-item
            v-if="
              $store.getters.role == 'User' ||
              $store.getters.role == 'EbayOperator' ||
              $store.getters.role == 'InstitutionManager' ||
              $store.getters.role == 'InstitutionAdmin' ||
              $store.getters.role == 'LekoAdmin' ||
              $store.getters.role == 'LekoEmployee' ||
              $store.getters.role == 'SuperAdmin'
            "
            :to="{ name: items.repositories.href }"
            active-class="title black--text redColor"
            class="menuList2 listHover"
          >
            <template #prepend>
              <v-icon class="list-content-2">
                <img
                  height="24"
                  width="24"
                  src="@/assets/icons/repositories.svg"
                />
              </v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.repositories.title
            }}</v-list-item-title>
          </v-list-item>
          <!--------------------------------------WARRANTIES--------------------------------------->
          <v-list-item
            v-if="
              $store.getters.role == 'LekoAdmin' ||
              $store.getters.role == 'LekoEmployee' ||
              $store.getters.role == 'InstitutionAdmin' ||
              $store.getters.role == 'SuperAdmin'
            "
            :to="{ name: items.warranties.href }"
            active-class="title black--text redColor"
            class="menuList2 listHover"
          >
            <template #prepend>
              <v-icon class="list-content-2">mdi-receipt</v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.warranties.title
            }}</v-list-item-title>
          </v-list-item>
          <!-----------------------------------VEHICLE LOCATION------------------------------------>
          <v-list-item
            v-if="
              $store.getters.role == 'User' ||
              $store.getters.role == 'EbayOperator' ||
              $store.getters.role == 'InstitutionManager' ||
              $store.getters.role == 'InstitutionAdmin' ||
              $store.getters.role == 'LekoAdmin' ||
              $store.getters.role == 'LekoEmployee' ||
              $store.getters.role == 'SuperAdmin'
            "
            :to="{ name: items.vehicles.href4 }"
            active-class="title black--text redColor"
            class="menuList2 listHover"
          >
            <template #prepend>
              <v-icon class="list-content-2">
                <img
                  height="24"
                  width="24"
                  src="@/assets/icons/car-location.svg"
                />
              </v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.vehicles.subtitle4
            }}</v-list-item-title>
          </v-list-item>
          <!-------------------------------------CAR VERSIONS-------------------------------------->
          <v-list-item
            v-if="
              $store.getters.role == 'User' ||
              $store.getters.role == 'EbayOperator' ||
              $store.getters.role == 'InstitutionManager' ||
              $store.getters.role == 'InstitutionAdmin' ||
              $store.getters.role == 'LekoAdmin' ||
              $store.getters.role == 'LekoEmployee' ||
              $store.getters.role == 'SuperAdmin'
            "
            :to="{ name: items.vehicles.href3 }"
            active-class="title black--text redColor"
            class="menuList2 listHover"
          >
            <template #prepend>
              <v-icon class="list-content-2">
                <img height="24" width="24" src="@/assets/icons/vehicles.svg" />
              </v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.vehicles.subtitle3
            }}</v-list-item-title>
          </v-list-item>
          <!-----------------------------------------USERS----------------------------------------->
          <v-list-item
            v-if="
              $store.getters.role == 'LekoAdmin' ||
              $store.getters.role == 'LekoEmployee' ||
              $store.getters.role == 'InstitutionAdmin' ||
              $store.getters.role == 'SuperAdmin'
            "
            :to="{ name: items.users.href }"
            active-class="title black--text redColor"
            class="menuList2 listHover"
          >
            <template #prepend>
              <v-icon class="list-content-2">
                <img height="24" width="24" src="@/assets/icons/users.svg" />
              </v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.users.title
            }}</v-list-item-title>
          </v-list-item>
          <!----------------------------------------CLIENTS---------------------------------------->
          <v-list-item
            v-if="
              $store.getters.role == 'User' ||
              $store.getters.role == 'EbayOperator' ||
              $store.getters.role == 'InstitutionManager' ||
              $store.getters.role == 'InstitutionAdmin' ||
              $store.getters.role == 'LekoAdmin' ||
              $store.getters.role == 'LekoEmployee' ||
              $store.getters.role == 'SuperAdmin'
            "
            :to="{ name: items.clients.href }"
            active-class="title black--text redColor"
            class="menuList2 listHover"
          >
            <template #prepend>
              <v-icon class="list-content-2">
                <img height="24" width="24" src="@/assets/icons/clients.svg" />
              </v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.clients.title
            }}</v-list-item-title>
          </v-list-item>
          <!----------------------------------------PLATES---------------------------------------->
          <v-list-item
            v-if="
              $store.getters.role == 'User' ||
              $store.getters.role == 'EbayOperator' ||
              $store.getters.role == 'InstitutionManager' ||
              $store.getters.role == 'InstitutionAdmin' ||
              $store.getters.role == 'LekoAdmin' ||
              $store.getters.role == 'LekoEmployee' ||
              $store.getters.role == 'SuperAdmin'
            "
            :to="{ name: items.plates.href }"
            active-class="title black--text redColor"
            class="menuList2 listHover"
          >
            <template #prepend>
              <v-icon class="list-content-2"> mdi-car-search </v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.plates.title
            }}</v-list-item-title>
          </v-list-item>
          <!----------------------------------------RR PASS RESET-------------------------------------->
          <v-list-item
            v-if="$store.getters.role == 'SuperAdmin'"
            :to="{ name: items.rrPassReset.href }"
            active-class="title black--text redColor"
            class="menuList2 listHover"
          >
            <template #prepend>
              <v-icon class="list-content-2">mdi-lock-reset</v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">
              {{ items.rrPassReset.title }}
            </v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!--------------------------------------MODULI RR--------------------------------------->
       
        <v-list-group
          v-if="
            $store.getters.role == 'SuperAdmin' ||
            $store.getters.role == 'LekoAdmin' ||
            ($store.getters.role == 'InstitutionAdmin' &&
              $store.getters.aziendaRR == true)
          "
          value="moduliRr"
        >
          <template #activator="{ props, isOpen }">
            <v-list-item
              v-bind="props"
              active-class="title black--text redColor"
              class="menuList listHover"
            >
              <template #prepend>
                <v-icon>mdi-view-dashboard-outline</v-icon>
              </template>
              <v-list-item-title
                class="listHover blueText"
                :class="mini ? 'd-none' : 'title-font-size'"
              >
                {{ items.moduliRr.title }}
              </v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item
            :to="{ name: items.moduliRr.href }"
            active-class="title black--text redColor"
            class="menuList2 listHover"
          >
            <template #prepend>
              <v-icon class="list-content-2">mdi-view-dashboard</v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">
              {{ items.moduliRr.subtitle }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            :to="{ name: items.moduliRr.href1 }"
            active-class="title black--text redColor"
            class="menuList2 listHover"
          >
            <template #prepend>
              <v-icon class="list-content-2">mdi-clipboard-list-outline</v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">
              {{ items.moduliRr.subtitle1 }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            :to="{ name: items.moduliRr.href2 }"
            active-class="title black--text redColor"
            class="menuList2 listHover"
          >
            <template #prepend>
              <v-icon class="list-content-2">mdi-cash-register</v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">
              {{ items.moduliRr.subtitle2 }}
            </v-list-item-title>
          </v-list-item>
        </v-list-group>
      
        <!--------------------------------------INSTITUTIONS--------------------------------------->
        <v-list-item
          v-if="
            $store.getters.role == 'LekoAdmin' ||
            $store.getters.role == 'LekoEmployee' ||
            $store.getters.role == 'SuperAdmin'
          "
          :to="{ name: items.institutions.href }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>mdi-domain</v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            items.institutions.title
          }}</v-list-item-title>
        </v-list-item>
        <!-----------------------------------------CITIES------------------------------------------>
        <v-list-item
          v-if="
            $store.getters.role == 'LekoAdmin' ||
            $store.getters.role == 'LekoEmployee' ||
            $store.getters.role == 'SuperAdmin'
          "
          :to="{ name: items.cities.href }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>mdi-city</v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            items.cities.title
          }}</v-list-item-title>
        </v-list-item>
        <!-----------------------------------------STATES------------------------------------------>
        <v-list-item
          v-if="
            $store.getters.role == 'LekoAdmin' ||
            $store.getters.role == 'LekoEmployee' ||
            $store.getters.role == 'SuperAdmin'
          "
          :to="{ name: items.states.href }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>mdi-earth</v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            items.states.title
          }}</v-list-item-title>
        </v-list-item>
        <!-----------------------------------------QUALITY----------------------------------------->
        <v-list-item
          v-if="
            $store.getters.role == 'LekoAdmin' ||
            $store.getters.role == 'LekoEmployee' ||
            $store.getters.role == 'SuperAdmin'
          "
          :to="{ name: items.quality.href }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>mdi-star-half-full</v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            items.quality.title
          }}</v-list-item-title>
        </v-list-item>
            <!------------------------------------RR SHOP VISIBILITY------------------------------------>
        <v-list-item
          v-if="
            ($store.getters.role == 'InstitutionAdmin' &&
              $store.getters.rr_member == true) ||
            $store.getters.role == 'LekoAdmin' ||
            $store.getters.role == 'SuperAdmin'
          "
          :to="{ name: 'rr-display' }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>mdi-storefront-outline</v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">
            {{ $t("rr_display.nav_title") }}
          </v-list-item-title>
        </v-list-item>
        <!--------------------------------------COMMON CODES--------------------------------------->
        <v-list-item
          v-if="
            $store.getters.role == 'User' ||
            $store.getters.role == 'EbayOperator' ||
            $store.getters.role == 'InstitutionManager' ||
            $store.getters.role == 'InstitutionAdmin' ||
            $store.getters.role == 'LekoAdmin' ||
            $store.getters.role == 'LekoEmployee' ||
            $store.getters.role == 'SuperAdmin'
          "
          :to="{ name: items.commonCodes.href }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>mdi-information-outline</v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            items.commonCodes.title
          }}</v-list-item-title>
        </v-list-item>
        <!-----------------------------------OEM STOCK WATCHLIST----------------------------------->
        <v-list-item
          v-if="
            $store.getters.role == 'User' ||
            $store.getters.role == 'EbayOperator' ||
            $store.getters.role == 'InstitutionManager' ||
            $store.getters.role == 'InstitutionAdmin' ||
            $store.getters.role == 'LekoAdmin' ||
            $store.getters.role == 'LekoEmployee' ||
            $store.getters.role == 'SuperAdmin'
          "
          :to="{ name: items.oemStockWatchlist.href }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>mdi-playlist-check</v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            items.oemStockWatchlist.title
          }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="
            $store.getters.role == 'LekoAdmin' ||
            $store.getters.role == 'SuperAdmin' ||
            $store.getters.institutionExportEbayLeko
          "
          :to="{ name: items.institutionEbay.href }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>mdi-currency-eur</v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">
            {{ items.institutionEbay.title }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="
            $store.getters.role == 'SuperAdmin' ||
            ($store.getters.role == 'InstitutionAdmin' &&
              $store.getters.institutionExportEbayLeko)
          "
          :to="{ name: items.ebayExclusions.href }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>mdi-cancel</v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">
            {{ items.ebayExclusions.title }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="$store.getters.role == 'SuperAdmin'"
          :to="{ name: items.listingRefresh.href }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>mdi-refresh</v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">
            {{ items.listingRefresh.title }}
          </v-list-item-title>
        </v-list-item>
        <!--------------------------------------SHIPPING BULK IMPORT---------------------------------->
        <v-list-item
          v-if="$store.getters.role == 'SuperAdmin'"
          :to="{ name: items.shippingBulkImport.href }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>mdi-file-upload-outline</v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">
            {{ items.shippingBulkImport.title }}
          </v-list-item-title>
        </v-list-item>
        <!------------------------------------------TESTS------------------------------------------>
        <v-list-item
          v-if="
            $store.getters.role == 'LekoAdmin' ||
            $store.getters.role == 'LekoEmployee' ||
            $store.getters.role == 'SuperAdmin'
          "
          :to="{ name: items.tests.href }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>mdi-flask</v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            items.tests.title
          }}</v-list-item-title>
        </v-list-item>
        <!------------------------------------REFERRAL PROGRAM------------------------------------>
        <v-list-item
          v-if="
            $store.getters.role == 'InstitutionAdmin' ||
            $store.getters.role == 'InstitutionManager' ||
            $store.getters.role == 'User' ||
            $store.getters.role == 'EbayOperator' ||
            $store.getters.role == 'LekoAdmin' ||
            $store.getters.role == 'SuperAdmin'
          "
          :to="{ name: 'referral-program' }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>mdi-account-multiple-plus-outline</v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">
            Programma Referral
          </v-list-item-title>
        </v-list-item>
    
        <!--------------------------------------LEKOTECH AI-------------------------------------->
        <v-list-group value="ai">
          <template #activator="{ props, isOpen }">
            <v-list-item
              v-bind="props"
              active-class="title black--text redColor"
              class="menuList listHover"
            >
              <template #prepend>
                <v-icon>mdi-robot</v-icon>
              </template>
              <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">
                LekoTech AI
              </v-list-item-title>
            </v-list-item>
          </template>

          <!-- Lekotech AI item 1 -->
          <v-list-item
            :to="{ name: items.lekoAI.href1 }"
            active-class="title black--text redColor"
            class="menuList listHover"
          >
            <template #prepend>
              <v-icon>
                <img
                  src="@/assets/icons/engine.png"
                  width="24"
                  height="24"
                  contain
                />
              </v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">
              {{ items.lekoAI.subtitle1 }}
            </v-list-item-title>
          </v-list-item>

          <!-- Lekotech AI item 2 -->
          <v-list-item
            :to="{ name: items.lekoAI.href2 }"
            active-class="title black--text redColor"
            class="menuList listHover"
          >
            <template #prepend>
              <v-icon>
                <img
                  src="@/assets/icons/vehicle_entry.png"
                  width="24"
                  height="24"
                  contain
                />
              </v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">
              {{ items.lekoAI.subtitle2 }}
            </v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!--------------------------------------EBAY DOCUMENTATION-------------------------------------->
        <v-list-group value="ebay-docs">
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              active-class="title black--text redColor"
              class="menuList listHover"
            >
              <template #prepend>
                <v-icon>mdi-storefront-outline</v-icon>
              </template>
              <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
                items.ebayDocs.title
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item
            :to="{ name: items.ebayDocs.hrefUseCases }"
            active-class="title black--text redColor"
            class="menuList listHover"
          >
            <template #prepend>
              <v-icon>mdi-file-document</v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.ebayDocs.subtitleUseCases
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            :to="{ name: items.ebayDocs.hrefInvoices }"
            active-class="title black--text redColor"
            class="menuList listHover"
          >
            <template #prepend>
              <v-icon>mdi-file-document</v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.ebayDocs.subtitleInvoices
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="
              $store.getters.role == 'LekoAdmin' ||
              $store.getters.role == 'SuperAdmin' ||
              $store.getters.institutionExportEbayLeko
            "
            :to="{ name: items.ebayDocs.hrefCategories }"
            active-class="title black--text redColor"
            class="menuList listHover"
          >
            <template #prepend>
              <v-icon>mdi-file-document</v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.ebayDocs.subtitleCategories
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="
              $store.getters.role == 'SuperAdmin' ||
              $store.getters.role == 'LekoAdmin'
            "
            :to="{ name: items.ebayDocs.hrefEditCategories }"
            active-class="title black--text redColor"
            class="menuList listHover"
          >
            <template #prepend>
              <v-icon>mdi-file-document</v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.ebayDocs.subtitleEditCategories
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            :to="{ name: items.ebayDocs.hrefInternationalShipping }"
            active-class="title black--text redColor"
            class="menuList listHover"
          >
            <template #prepend>
              <v-icon>mdi-file-document</v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.ebayDocs.subtitleInternationalShipping
            }}</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!--------------------------------------DOCUMENTATION-------------------------------------->
        <v-list-group value="documentation">
          <template #activator="{ props, isOpen }">
            <v-list-item
              v-bind="props"
              active-class="title black--text redColor"
              class="menuList listHover"
            >
              <template #prepend>
                <v-icon>mdi-file-document-outline</v-icon>
              </template>
              <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
                items.documentation.title
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <!--INTRODUCTION-->
          <v-list-item
            :to="{ name: items.documentation.href2 }"
            active-class="title black--text redColor"
            class="menuList listHover"
          >
            <template #prepend>
              <v-icon>mdi-file-document</v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.documentation.subtitle2
            }}</v-list-item-title>
          </v-list-item>
          <!--SEARCH TERMS-->
          <v-list-item
            :to="{ name: items.documentation.hrefSearchTerms }"
            active-class="title black--text redColor"
            class="menuList listHover"
          >
            <template #prepend>
              <v-icon>mdi-file-document</v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.documentation.subtitle3
            }}</v-list-item-title>
          </v-list-item>
          <!--DISMANTLING AND COMPLIANCE-->
          <v-list-item
            :to="{ name: items.documentation.hrefCompliance }"
            active-class="title black--text redColor"
            class="menuList listHover"
          >
            <template #prepend>
              <v-icon>mdi-file-document</v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.documentation.subtitleCompliance
            }}</v-list-item-title>
          </v-list-item>
          <!-- RR shipping costs docs (RR members only) -->
          <v-list-item
            v-if="
              $store.getters.rr_member == true ||
              $store.getters.role == 'LekoAdmin' ||
              $store.getters.role == 'SuperAdmin'
            "
            :to="{ name: items.documentation.href7 }"
            active-class="title black--text redColor"
            class="menuList listHover"
          >
            <template #prepend>
              <v-icon>mdi-file-document</v-icon>
            </template>
            <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
              items.documentation.subtitle8
            }}</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-item
          :to="{ name: items.supportTicketsDocs.href }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>mdi-ticket-outline</v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            items.supportTicketsDocs.title
          }}</v-list-item-title>
        </v-list-item>
        <!--------------------------------------MAINTENANCE NOTICE---------------------------------->
        <v-list-item
          v-if="$store.getters.role == 'SuperAdmin'"
          :to="{ name: items.maintenanceNotice.href }"
          active-class="title black--text redColor"
          class="menuList listHover"
        >
          <template #prepend>
            <v-icon>mdi-alert-circle-outline</v-icon>
          </template>
          <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">{{
            items.maintenanceNotice.title
          }}</v-list-item-title>
        </v-list-item>
      </v-list>

      <v-spacer />

      <!-- LANGUAGE -->
      <v-row v-if="!mini" column class="darken-4 pa-1">
        <v-col>
          <v-select
            v-model="language"
            :items="languages"
            :item-title="() => ''"
            item-value="locale"
            solo
            hide-details
            location="bottom"
          >
            <!-- Custom dropdown items -->
            <template #item="{ props, item }">
              <v-list-item v-bind="props">
                <v-list-item-title class="d-flex align-center">
                  <img
                    :src="getImg(item.raw.flag)"
                    width="25"
                    height="25"
                    class="mr-2"
                  />
                  {{ item.raw.title }}
                </v-list-item-title>
              </v-list-item>
            </template>

            <!-- Custom selected value -->
            <template #selection="{ item }">
              <span class="d-flex align-center">
                <img
                  :src="getImg(item.raw.flag)"
                  width="25"
                  height="25"
                  class="mr-2"
                />
                {{ item.raw.title }}
              </span>
            </template>
          </v-select>
        </v-col>
      </v-row>
      <v-list-item
        v-if="
          $store.getters.role == 'InstitutionAdmin' &&
          $store.getters.rr_member == true
        "
        active-class="title black--text redColor"
        class="menuList listHover"
      >
        <template #prepend>
          <v-icon class="ml-2">mdi-account-check</v-icon>
        </template>
        <v-list-item-title :class="mini ? 'd-none' : 'title-font-size'">
          {{ $t("rr_member") }}
          <img
            height="20"
            width="20"
            class="ml-auto"
            src="@/assets/rr-logo.png"
        /></v-list-item-title>
      </v-list-item>
    </v-navigation-drawer>
    <!-------------------------------------------TOOLBAR------------------------------------------->
    <v-app-bar v-if="logged" theme="dark" fixed clipped-left app>
      <v-app-bar-nav-icon
        v-if="$vuetify.display.mdAndDown"
        @click.stop="drawer = !drawer"
      />
      <v-spacer />

      <v-row
        v-if="$vuetify.display.mdAndUp"
        align="center"
        class="pr-4"
        dense
        no-gutters
      >
        <!-- <v-col>
          <v-icon color="white"> mdi-bell-outline </v-icon>
          <v-icon color="red"> mdi-bell-badge </v-icon>
        </v-col> -->

        <v-col cols="12" class="text-right">
          <span class="white--text font-weight-bold">
            <span class="">
              <!-- <v-menu
                v-model="menu"
                location="bottom end"
                :close-on-content-click="false"
              >
                <template #activator="{ props }">
                  
                </template>
                
              </v-menu> -->

              <v-menu>
                <template #activator="{ props }">
                  <v-btn v-bind="props" icon variant="text" size="x-small">
                    <v-badge
                      v-if="notifications.unread > 0"
                      :content="notifications.unread"
                      color="red"
                      offset-x="4"
                      offset-y="4"
                    >
                      <v-icon size="28" color="red">mdi-bell-outline</v-icon>
                    </v-badge>
                    <v-icon v-else size="28" color="white"
                      >mdi-bell-outline</v-icon
                    >
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <v-card width="330">
                      <v-card-title
                        class="d-flex justify-space-between align-center py-2"
                      >
                        <span class="text-h6">{{ $t("notifications") }}</span>
                        <v-btn
                          size="small"
                          color="green-darken-4"
                          @click="notifications.markAllRead()"
                        >
                          {{ $t("mark_all_read") }}
                          <v-icon end>mdi-check-all</v-icon>
                        </v-btn>
                      </v-card-title>

                      <v-divider />

                      <v-list class="max-h-64" style="overflow-y: auto">
                        <v-list-item
                          v-for="(note, index) in notifications.items"
                          :key="index"
                          @click="openNotification(note)"
                        >
                          <v-list-item-title>
                            <img
                              v-if="note.origin && note.origin == 'retericambi'"
                              height="20"
                              width="20"
                              class="ml-auto"
                              src="@/assets/rr-logo.png"
                            />
                            <span
                              v-else-if="note.origin === 'ebay_return'"
                              class="toast-icon-row toast-icon-row--menu"
                            >
                              <v-icon size="18" color="#fb8c00"
                                >mdi-alert-circle</v-icon
                              >
                              <img
                                height="24"
                                width="24"
                                src="@/assets/icons/ebay_colored.png"
                                alt="eBay"
                              />
                            </span>
                            <img
                              v-else-if="note.origin === 'ebay'"
                              height="28"
                              width="28"
                              class="ml-auto"
                              src="@/assets/icons/ebay_colored.png"
                              alt="eBay"
                            />
                            {{ note.title }}</v-list-item-title
                          >
                          <v-list-item-subtitle>{{
                            note.body
                          }}</v-list-item-subtitle>
                          <v-list-item-subtitle class="text-grey">
                            {{ note.date }} {{ note.time }}
                          </v-list-item-subtitle>
                          <hr />
                        </v-list-item>

                        <v-list-item v-if="notifications.items.length === 0">
                          <v-list-item-title>{{
                            $t("no_notifications")
                          }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-list-item>
                </v-list>
              </v-menu>

              <div
                v-if="notifications.items && notifications.items.length > 0"
                class="alerts-container"
              >
                <v-alert
                  v-for="note in notifications.items"
                  :key="note.id"
                  :model-value="note.showToast"
                  :class="notificationToastClass(note)"
                  border="start"
                  elevation="12"
                  variant="flat"
                  @click="openNotification(note)"
                >
                  <div class="toast-content">
                    <img
                      v-if="note.origin && note.origin == 'retericambi'"
                      height="20"
                      width="20"
                      class="ml-auto mt-1"
                      src="@/assets/rr-logo.png"
                    />
                    <span
                      v-else-if="note.origin === 'ebay_return'"
                      class="toast-icon-row mt-1"
                    >
                      <v-icon size="26" color="#fb8c00"
                        >mdi-alert-circle</v-icon
                      >
                      <img
                        height="32"
                        width="32"
                        src="@/assets/icons/ebay_colored.png"
                        alt="eBay"
                      />
                    </span>
                    <img
                      v-else-if="note.origin === 'ebay'"
                      height="36"
                      width="36"
                      class="ml-auto mt-1"
                      src="@/assets/icons/ebay_colored.png"
                      alt="eBay"
                    />
                    <div class="toast-text">
                      <div class="toast-title">{{ note.title }}</div>
                      <div class="toast-body">{{ note.body }}</div>
                      <div class="toast-body">
                        <small> {{ note.date }} - {{ note.time }} </small>
                      </div>
                    </div>

                    <v-spacer></v-spacer>
                    <v-btn
                      icon
                      size="small"
                      @click.stop="closeNotification(note)"
                    >
                      <v-icon size="20">mdi-close</v-icon>
                    </v-btn>
                  </div>
                </v-alert>
              </div> </span
            >| {{ $store.getters.userName }} |
            {{ getRole($store.getters.role) }}
          </span>
        </v-col>
        <v-col cols="12" class="text-right">
          <span class="white--text font-weight-bold">
            {{ $t("approved_parts") }}:
            {{ $store.getters.approvedPartsNumber }} |
            {{ $t("institutions.form.used_plates") }}:
            {{ $store.getters.usedPlatesNumber }}
            | {{ $t("institutions.form.remaining_plates") }}:
            {{ $store.getters.remainingPlatesNumber }}
          </span>
        </v-col>
      </v-row>

      <v-btn
        v-if="$vuetify.display.smAndUp"
        color="red"
        variant="flat"
        @click="logout"
      >
        {{ $t("logout") }}
        <v-icon end light> mdi-logout-variant </v-icon>
      </v-btn>
      <v-btn v-else icon large variant="flat" class="mr-4" @click="logout">
        <v-icon light> mdi-logout-variant </v-icon>
      </v-btn>
    </v-app-bar>
    <!--------------------------------------------------------------------------------------------->
    <v-main>
      <v-fade-transition mode="out-in">
        <div>
          <!--LOADING DIALOG-->
          <v-dialog v-model="loading" hide-overlay persistent width="300">
            <v-card color="red-darken-3" dark>
              <v-card-text>
                {{ $t("loading") }}
                <v-progress-linear indeterminate color="white" class="mb-0" />
              </v-card-text>
            </v-card>
          </v-dialog>
          <!--PAGE-->
          <router-view />
        </div>
      </v-fade-transition>
    </v-main>
    <v-snackbar
      v-model="inboxSnackbar.value"
      :color="inboxSnackbar.color"
      location="top"
      :timeout="8000"
    >
      {{ inboxSnackbar.text }}
    </v-snackbar>
    <!--------------------------------------------------------------------------------------------->
    <v-footer class="pl-3" theme="dark" app>
      <span>© {{ currentYear }} - LEKO Tech, All Right Reserved.</span>
      <v-spacer /><a
        href="https://lekotech.com/privacy-policy/"
        target="blank"
        style="color: #e84a4a; padding-right: 10px"
        >Termini e condizioni</a
      >
    </v-footer>
  </v-app>
</template>

<script type="text/babel">
// import Vue from 'vue';
import { GlobalEvents } from "vue-global-events";
import postRequest from "./api/postRequest";
import WhatsappInboxButton from "@/components/WhatsApp/WhatsappInboxButton.vue";
import { hasPortalPermission, PORTAL_PERMISSIONS } from "@/utils/portalPermissions";

// Vue.component('global-events', GlobalEvents);
import { notifications } from "./notifications";
import { ui } from "./ui";
import { ensureWebPush } from "./firebase";

let fcmWebToken = null;
fcmWebToken = localStorage.getItem("fcmWebToken");
let timeout;

export default {
  components: {
    GlobalEvents,
    WhatsappInboxButton,
  },
  data: () => ({
    token: localStorage.token,
    drawer: true,
    mini: false,
    navScrollTop: 0,
    items: {
      home: {
        href: "home",
        router: true,
        title: "",
        icon: "home",
      },
      settings: {
        href: "settings",
        router: true,
        title: "",
        icon: "settings",
      },
      settings2: {
        title: "",
        icon: "settings",
      },
      whatsappInbox: {
        title: "",
      },
      moduliRr: {
        title: "",
        subtitle: "",
        subtitle1: "",
        subtitle2: "",
        href: "moduli-rr-overview",
        href1: "moduli-rr-orders",
        href2: "moduli-rr-sales",
        router: true,
        icon: "dashboard",
      },
      leko: {
        href: "approve-parts",
        href1: "test-its",
        href2: "approve-users",
        href3: "shippings",
        href4: "car-part-groups",
        href5: "tools",
        href6: "ebay-shipping-price",
        router: true,
        title: "LEKO Employees",
        subtitle: "Approve Parts",
        subtitle1: "Test ITS",
        subtitle2: "Approve Users",
        subtitle3: "Shippings",
        subtitle4: "Car Part Groups",
        subtitle5: "Tools",
        subtitle6: "Ebay Shipping Price",
        icon: "engineering",
      },
      institutionEbay: {
        href: "institution-ebay-shipping-price",
        title: "Institution ebay shipping price",
      },
      ebayExclusions: {
        href: "ebay-exclusions",
        title: "eBay exclusions",
      },
      listingRefresh: {
        href: "listing-refresh",
        title: "Listing refresh",
      },
      maintenanceNotice: {
        href: "global-settings",
        title: "Global settings",
      },
      shippingBulkImport: {
        href: "shipping-bulk-import",
        title: "Shipping Bulk Import",
      },
      rrPassReset: {
        href: "rr-pass-reset",
        title: "RR Pass Reset",
      },
      partRequests: {
        href: "part-requests",
        router: true,
        title: "",
        subtitle: "",
        icon: "store",
      },
      sales: {
        href: "sales",
        router: true,
        title: "",
        icon: "attach_money",
      },
      reservations: {
        href: "reservations",
        router: true,
        title: "",
        subtitle: "",
        icon: "event",
      },
      users: {
        href: "users",
        router: true,
        title: "",
        icon: "people",
      },
      clients: {
        href: "clients",
        router: true,
        title: "",
        icon: "people",
      },
      institutions: {
        href: "institutions",
        router: true,
        title: "",
        icon: "domain",
      },
      repositories: {
        href: "repositories",
        router: true,
        title: "",
        icon: "meeting_room",
      },
      parts: {
        title: "Manage Parts",
        subtitle: "Insert Parts",
        subtitle1: "Inventory",
        subtitle2: "Ordered Parts",
        subtitle3: "Damaged Parts",
        subtitle4: "Lost Parts",
        subtitle5: "Recycled Parts",
        subtitle6: "Movements",
        href: "insert-parts",
        href1: "inventory",
        href2: "ordered",
        href3: "damaged",
        href4: "lost",
        href5: "recycled",
        href6: "movements",
        icon: "settings",
      },
      cities: {
        href: "cities",
        router: true,
        title: "",
        icon: "location_city",
      },
      states: {
        href: "states",
        router: true,
        title: "",
        icon: "public",
      },
      quality: {
        href: "quality",
        router: true,
        title: "",
        icon: "star_half",
      },
      warranties: {
        href: "warranties",
        router: true,
        title: "",
        icon: "assignment",
      },
      priceOneAverages: {
        href: "price-one-averages",
        router: true,
        title: "",
        icon: "cash-multiple",
      },
      commonCodes: {
        href: "common-codes",
        router: true,
        title: "",
        icon: "info",
      },
      oemStockWatchlist: {
        href: "oem-stock-watchlist",
        router: true,
        title: "",
        icon: "playlist-check",
      },
      tests: {
        href: "tests",
        router: true,
        title: "",
        icon: "build",
      },
      lekoAI: {
        href1: "lekoTechAi",
        href2: "partsWithAI",
        router: true,
        title: "",
        icon: "description",
        subtitle1: "LekoTech AI",
        subtitle2: "Parts AI Label",
      },
      documentation: {
        href1: "documentation",
        href2: "introduction",
        hrefSearchTerms: "search-terms",
        hrefCompliance: "compliance-docs",
        href7: "ebay-rr-shipping-docs",
        router: true,
        title: "",
        icon: "description",
        subtitle1: "API Documentation",
        subtitle2: "Introduction",
        subtitle3: "Search Terms",
        subtitleCompliance: "Dismantling and Compliance",
        subtitle8: "RR Shipping Costs",
      },
      ebayDocs: {
        hrefUseCases: "ebay-documentation",
        hrefInvoices: "ebay-invoices-shipping-docs",
        hrefCategories: "ebay-categories",
        hrefEditCategories: "edit-ebay-categories",
        hrefInternationalShipping: "international-ebay-shipping",
        router: true,
        title: "eBay",
        subtitleUseCases: "",
        subtitleInvoices: "",
        subtitleCategories: "",
        subtitleEditCategories: "",
        subtitleInternationalShipping: "",
      },
      supportTicketsDocs: {
        href: "support-tickets-docs",
        title: "Support Tickets",
      },
      vehicles: {
        title: "Manage Vehicles",
        subtitle1: "Shipments",
        subtitle2: "Vehicle Entry",
        subtitle3: "Car Versions",
        subtitle4: "Car Locations",
        href1: "shipments",
        href2: "vehicle-entry",
        href3: "car-versions",
        href4: "car-locations",
        router: true,
        icon: "directions_car",
      },
      plates: {
        href: "plate-logs",
        router: true,
        title: "plate_logs",
        icon: "car-search",
      },
    },
    languages: [
      { title: "Italiano", locale: "it", flag: "it" },
      { title: "English", locale: "en", flag: "uk" },
      { title: "Deutch", locale: "de", flag: "de" },
      { title: "Français", locale: "fr", flag: "fr" },
      { title: "Espanol", locale: "es", flag: "es" },
      { title: "Shqip", locale: "sq", flag: "al" },
    ],
    language: null,
    inboxSnackbar: {
      value: false,
      text: "",
      color: "error",
    },
    notifications,
    ui,
  }),
  computed: {
    logged() {
      if (this.$store.getters.logged === true) {
        this.setLanguage();
        this.getLocale();
        this.checkToken();
      }
      return this.$store.getters.logged;
    },
    role() {
      return this.$store.getters.role;
    },
    loading() {
      return this.$store.getters.loading;
    },
    currentYear() {
      return new Date().getFullYear();
    },
    canWhatsAppInbox() {
      return hasPortalPermission(this.$store, PORTAL_PERMISSIONS.WHATSAPP_INBOX);
    },
  },
  watch: {
    $route() {
      this.restoreNavScroll();
    },
    logged: {
      immediate: true,
      handler(value) {
        if (value) {
          this.bindNavScroll();
          this.bindWebPush();
        } else {
          this.unbindNavScroll();
          notifications.clear();
        }
      },
    },
    "$vuetify.display": {
      handler(data) {
        // Disable mini drawer on small devices.
        if (data && data.mdAndDown) this.mini = false;
      },
    },
    language: {
      handler(value) {
        localStorage.setItem("language", value);
        this.$store.dispatch("languageAction", value);
        this.$i18n.locale = this.$store.getters.language;
      },
    },
    watch: {
      "notifications.items": {
        handler(newVal) {
          const latest = newVal[0];
          if (latest?.showToast) {
            // Play sound, animate toast, etc.
            // console.log("New notification:", latest.title);
          }
        },
        deep: true,
      },
    },
  },
  created() {
    this.setInactiveTimeout();
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data?.type === "NEW_NOTIFICATION") {
          const now = new Date();
          notifications.add({
            title: event.data.title,
            body: event.data.body,
            date: now.toLocaleDateString(),
            time: now.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            }),
            qr: event.data.qr ? event.data.qr : null,
            origin: event.data.origin ? event.data.origin : null,
          });
        }
      });
    }
  },
  mounted() {
    this.bindNavScroll();
  },
  beforeUnmount() {
    this.unbindNavScroll();
  },
  methods: {
    openWhatsappInboxFromMenu() {
      const launcher = this.$refs.whatsappInboxLauncher;
      if (launcher && typeof launcher.openInbox === 'function') {
        launcher.openInbox();
      }
    },
    onWhatsappInboxError({ message, color }) {
      this.inboxSnackbar.text = message || this.$t('whatsappInbox.errorGeneric');
      this.inboxSnackbar.color = color || 'error';
      this.inboxSnackbar.value = true;
    },
    getDrawerScrollEl() {
      const root = this.$refs.navDrawer?.$el || this.$refs.navDrawer;
      return root?.querySelector?.(".v-navigation-drawer__content") || null;
    },
    async bindWebPush() {
      try {
        const { token } = await ensureWebPush();
        const userId = this.$store.getters.userId;
        if (!token || !userId) return;
        await postRequest.object("/user/webtoken-activate", {
          userId,
          fcmWebToken: token,
        });
      } catch {
        // FCM must never block or log the user out.
      }
    },
    bindNavScroll() {
      this.$nextTick(() => {
        const el = this.getDrawerScrollEl();
        if (!el || this._navScrollEl === el) return;
        this.unbindNavScroll();
        this._navScrollEl = el;
        el.addEventListener("scroll", this.saveNavScroll, { passive: true });
      });
    },
    unbindNavScroll() {
      if (!this._navScrollEl) return;
      this._navScrollEl.removeEventListener("scroll", this.saveNavScroll);
      this._navScrollEl = null;
    },
    saveNavScroll() {
      const el = this.getDrawerScrollEl();
      if (el) this.navScrollTop = el.scrollTop;
    },
    restoreNavScroll() {
      const apply = () => {
        const el = this.getDrawerScrollEl();
        if (el) el.scrollTop = this.navScrollTop;
      };
      apply();
      this.$nextTick(() => {
        apply();
        requestAnimationFrame(() => {
          apply();
          setTimeout(apply, 50);
          setTimeout(apply, 150);
        });
      });
    },
    getImg(item) {
      switch (item) {
        case "it":
          return "https://portal.lekotech.com/img/icons/ebayIcons/italy.svg";
        case "de":
          return "https://portal.lekotech.com/img/icons/ebayIcons/germany.svg";
        case "es":
          return "https://portal.lekotech.com/img/icons/ebayIcons/spain.svg";
        case "fr":
          return "https://portal.lekotech.com/img/icons/ebayIcons/france.svg";
        case "al":
          return "https://portal.lekotech.com/img/icons/ebayIcons/albania.png";
        case "uk":
          return "https://portal.lekotech.com/img/icons/ebayIcons/united-kingdom.svg";
        default:
          return "";
      }
    },
    setLanguage() {
      this.$i18n.locale = this.$store.getters.language;
      this.language = this.$store.getters.language;
    },
    getLocale() {
      this.items.home.title = this.$t("home.home");
      this.items.leko.title = this.$t("leko_employees.leko_employees");
      this.items.leko.subtitle = this.$t("leko_employees.approve_parts.label");
      this.items.leko.subtitle1 = this.$t("leko_employees.test_its.label");
      this.items.leko.subtitle2 = this.$t("leko_employees.approve_users.label");
      this.items.leko.subtitle3 = this.$t("leko_employees.shippings.label");
      this.items.leko.subtitle4 = this.$t(
        "leko_employees.car_part_groups.label",
      );
      this.items.leko.subtitle5 = this.$t("leko_employees.tools.label");
      this.items.leko.subtitle6 = this.$t(
        "leko_employees.ebay_shipping_price.label",
      );
      this.items.sales.title = this.$t("sales.manage_sales");
      this.items.reservations.title = this.$t("reservations.label");
      this.items.reservations.subtitle = this.$t("deprecated");
      this.items.users.title = this.$t("users.manage_users");
      this.items.clients.title = this.$t("clients.manage_clients");
      this.items.institutions.title = this.$t(
        "institutions.manage_institutions",
      );
      // this.items.cars.title = this.$t('cars.manage_cars');
      this.items.parts.title = this.$t("parts.manage_parts");
      this.items.parts.subtitle = this.$t("parts.insert_parts.label");
      this.items.parts.subtitle1 = this.$t("parts.inventory.label");
      this.items.parts.subtitle2 = this.$t("parts.ordered_parts.label");
      this.items.parts.subtitle3 = this.$t("parts.damaged_parts.label");
      this.items.parts.subtitle4 = this.$t("parts.lost_parts.label");
      this.items.parts.subtitle5 = this.$t("parts.recycled_parts.label");
      this.items.parts.subtitle6 = this.$t("parts.movements.label");
      this.items.repositories.title = this.$t(
        "repositories.manage_repositories",
      );
      this.items.cities.title = this.$t("cities.manage_cities");
      this.items.states.title = this.$t("states.manage_states");
      this.items.quality.title = this.$t("quality.manage_quality");
      this.items.warranties.title = this.$t("warranties.manage_warranties");
      this.items.tests.title = this.$t("tests.manage_tests");
      this.items.priceOneAverages.title = this.$t("price_one_averages.label");
      this.items.commonCodes.title = this.$t("common_codes.label");
      this.items.oemStockWatchlist.title = this.$t("oem_stock_watchlist.label");
      this.items.documentation.title = this.$t("documentation.label");
      this.items.documentation.subtitle1 = this.$t("documentation.subtitle1");
      this.items.documentation.subtitle2 = this.$t("documentation.subtitle2");
      this.items.documentation.subtitle3 = this.$t("documentation.subtitle3");
      this.items.documentation.subtitleCompliance = this.$t("documentation.compliance");
      this.items.documentation.subtitle8 = this.$t("documentation.subtitle8");
      this.items.ebayDocs.title = this.$t("documentation.ebay_group");
      this.items.ebayDocs.subtitleUseCases = this.$t("ebay_documentation.label");
      this.items.ebayDocs.subtitleInvoices = this.$t("ebayDocs.nav");
      this.items.ebayDocs.subtitleCategories = this.$t("documentation.subtitle5");
      this.items.ebayDocs.subtitleEditCategories = this.$t(
        "documentation.subtitle6",
      );
      this.items.ebayDocs.subtitleInternationalShipping = this.$t(
        "documentation.subtitle7",
      );
      this.items.supportTicketsDocs.title = this.$t("support_tickets_docs.label");
      this.items.lekoAI.title = this.$t("lekoAI.label");
      this.items.lekoAI.subtitle1 = this.$t("lekoAI.subtitle1");
      this.items.lekoAI.subtitle2 = this.$t("lekoAI.subtitle2");
      this.items.institutionEbay.title = this.$t("institutionEbay.label");
      this.items.ebayExclusions.title = this.$t("ebay_exclusions.nav");
      this.items.listingRefresh.title = this.$t("listing_refresh.nav");
      this.items.maintenanceNotice.title = this.$t("global_settings.nav");
      this.items.shippingBulkImport.title = this.$t("shippingBulkImport.label");
      this.items.rrPassReset.title = this.$t("rete_ricambi_pass_reset.menu_label");
      this.items.partRequests.title = this.$t("part_requests.label");
      this.items.partRequests.subtitle = this.$t("deprecated");
      this.items.vehicles.title = this.$t("vehicle_entry.manage_vehicles");
      this.items.vehicles.subtitle1 = this.$t("shipments.manage_shipments");
      this.items.vehicles.subtitle2 = this.$t("vehicle_entry.label");
      this.items.vehicles.subtitle3 = this.$t("institutions.cars.label");
      this.items.vehicles.subtitle4 = this.$t("car_locations.label");
      this.items.settings.title = this.$t("settings.label");
      this.items.whatsappInbox.title = this.$t("whatsappInbox.menu");
      this.items.settings2.title = this.$t("settings2.label");
      this.items.moduliRr.title = this.$t("moduli_rr.label");
      this.items.moduliRr.subtitle = this.$t("moduli_rr.overview");
      this.items.moduliRr.subtitle1 = this.$t("moduli_rr.orders");
      this.items.moduliRr.subtitle2 = this.$t("moduli_rr.sales");
      this.items.plates.title = this.$t("plate_logs");
    },
    getRole(role) {
      switch (role) {
        case "LekoAdmin":
          return this.$t("roles.leko_admin");
        case "SuperAdmin":
          return this.$t("roles.super_admin");
        case "LekoEmployee":
          return this.$t("users.table.leko_digitalization_employee");
        case "InstitutionAdmin":
          return this.$t("users.table.institution_admin");
        case "InstitutionManager":
          return this.$t("users.table.institution_manager");
        case "User":
          return this.$t("users.table.operator");
        case "EbayOperator":
          return this.$t("users.table.ebay_operator");
        default:
          return role;
      }
    },
    setInactiveTimeout() {
      timeout = setTimeout(
        () => {
          this.logout();
        },
        60 * 60 * 1000,
      );
    },
    refresh() {
      clearTimeout(timeout);
      this.setInactiveTimeout();
    },
    renewToken(token) {
      postRequest
        .object("/renew-token", { token })
        .then((response) => {
          localStorage.setItem("exp", response.data.exp);
          localStorage.setItem("token", response.data.token);
          this.checkToken();
        })
        .catch(() => {
          if (error) {
            this.logout();
          }
        });
    },
    checkToken() {
      const exp = parseInt(localStorage.getItem("exp"), 10);
      const token = localStorage.getItem("token");

      if (!exp || !token) {
        this.logout();
        return;
      }

      const expTime = exp - Date.now();
      const rnTime = expTime - 100000; // renew 100 sec before expiration

      if (rnTime <= 0) {
        this.renewToken(token);
      } else {
        setTimeout(() => this.renewToken(token), rnTime);
      }
    },
    async logout() {
      notifications.clear();
      fcmWebToken = localStorage.getItem("fcmWebToken");
      postRequest
        .object("/user/webtoken-deactivate", {
          userId: this.$store.getters.userId,
          fcmWebToken,
        })
        .then(() => {})
        .catch({});
      localStorage.removeItem("exp");
      localStorage.removeItem("token");
      localStorage.removeItem("language");
      localStorage.removeItem("standardsProfiles");
      localStorage.clear();
      this.$store.dispatch("logoutAction");
      this.$router.push({ path: "/auth" });
    },
    openNotification(note) {
      if (note.origin === "ebay" || note.origin === "ebay_return") {
        this.$router.push(note.qr ? `/sales?id=${note.qr}` : "/sales");
      } else if (note.qr) {
        this.$router.push(`/ordered?id=${note.qr}`);
      } else {
        this.$router.push(`/ordered`);
      }
      this.notifications.markRead(note.id);
      this.notifications.hideToast(note.id);
      // optionally remove from list:
      // this.notifications.remove(note.id);
    },

    closeNotification(note) {
      this.notifications.hideToast(note.id);
      // optionally mark as read when user dismisses toast
      this.notifications.markRead(note.id);
    },
    isEbayNotificationOrigin(origin) {
      return origin === "ebay" || origin === "ebay_return";
    },
    notificationToastClass(note) {
      return {
        "toast-alert": true,
        "toast-alert--ebay": note.origin === "ebay",
        "toast-alert--ebay-return": note.origin === "ebay_return",
      };
    },
  },
};
</script>
<style>
@import "./css/main.css";
.v-app-bar-title__content {
  width: 100% !important;
}
.nav-btn {
  margin-left: -20px;
  z-index: 99999;
}
.v-navigation-drawer__content {
  overflow-anchor: none;
}
.v-data-table .v-table__wrapper > table > thead > tr > th,
.v-data-table .v-table__wrapper > table tbody > tr > th {
  white-space: nowrap !important;
}
.v-toolbar-title__placeholder {
  overflow: visible !important;
}
.v-combobox__selection {
  height: auto !important;
}
.alerts-container {
  position: fixed;
  top: 70px;
  right: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 999999;
}

/* Toast style */
.toast-alert {
  background: linear-gradient(105deg, #71c696, #f6f7f9);
  border-left: 4px solid #4caf50 !important; /* green accent */
  color: #2b2b2b !important;
  padding: 12px 16px !important;
  min-width: 280px;
  max-width: 350px;
}

.toast-alert--ebay {
  background: #ffffff;
  border-left: 4px solid #e53238 !important;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
}

.toast-alert--ebay-return {
  background: #fff9f2 !important;
  border-left: 4px solid #ffb74d !important;
  box-shadow: 0 2px 10px rgba(255, 183, 77, 0.12);
  color: #4a3b2a !important;
}

.toast-icon-row {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.toast-icon-row--menu {
  vertical-align: middle;
  margin-right: 4px;
}

.toast-alert .v-alert__content {
  padding: 0 !important;
}

.toast-content {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.toast-title {
  font-weight: 700;
  font-size: 15px;
  margin-bottom: 3px;
  display: flex;
  justify-content: start;
}

.toast-body {
  font-size: 13px;
  opacity: 0.8;
  line-height: 16px;
  margin-top: -2px;
  display: flex;
  justify-content: start;
}

.toast-alert:hover {
  transform: translateX(-3px);
  transition: 0.15s ease-in-out;
}

.v-btn > .v-icon {
  color: #555 !important;
}

.alert-top-right {
  cursor: pointer;
  max-width: 350px;
}
.ebay-docs-group.v-list-group {
  --v-list-indent: 8px;
}
.ebay-docs-group .ebay-docs-child {
  min-height: auto;
  padding-inline-start: 36px !important;
  padding-inline-end: 12px !important;
  padding-top: 6px;
  padding-bottom: 6px;
}
.ebay-docs-group .ebay-docs-child .v-list-item__prepend {
  width: auto !important;
  margin-inline-end: 8px !important;
}
.ebay-docs-group .ebay-docs-child .v-list-item__spacer {
  display: none;
}
.ebay-docs-group .ebay-docs-child-icon {
  opacity: 0.9;
}
.ebay-docs-group .ebay-docs-child-title {
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  line-height: 1.3;
}
</style>
